import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { Player } from "@lottiefiles/react-lottie-player";
import whtsapplottie from '../../Assets/lottie/home1.json'
import Type from "../Home/Type";
function AboutCard() {
  return (
    <Card className="quote-card-view justify-content">
      
       <h1 className="heading-name" style={{ justifyContent: "center", marginTop: "50px" }}>
      
       We are     
      <strong className="main-name"> Habzon!</strong> We do...
    </h1>
    <hr  style={{
    color: '#D903FA',
    backgroundColor: '#D903FA',
    height: 10.5,
    width : 350,
    borderColor : '#D903FA'
}}/>
<Type style={{ justifyContent: "center", paddingTop: "50px" }}/>
    
      <Card.Body style={{ justifyContent: "center", paddingTop: "55px" }}>
        <blockquote className="blockquote mb-0">
          <h4 style={{ textAlign: "justify" }}>
          We are a team of experienced app and website developers 
          <h4>who can help you bring your ideas to life.  </h4>
          <h4> We offer a wide range of services, including </h4>

</h4>
<hr  style={{
    color: '#D903FA',
    backgroundColor: '#D903FA',
    height: 10.5,
    width : 350,
    borderColor : '#D903FA'
}}/>
<h4>
          ብምኩራት ሶፍትዌር ኢንጅነራት ዝመሓደር ናይ ሶፍትዌርን ግራፊክስ ስራሕ ዝሰርሕ ዌብሳይት። ነዞም ዝስዕቡ ኣገልግሎታት ድማ ንሰርሕ
          </h4>
  
          <ul>
    
            <li className="about-activity">
              <ImPointRight /> Creating Mobile |  ሞባይል አፕ
            </li>
            <li className="about-activity">
              <ImPointRight /> Building Website | ዌብሳይት
            </li>
            <li className="about-activity">
              <ImPointRight /> Graphic Design   | ግራፊክ ዲዛይን
            </li>
            <li className="about-activity">
              <ImPointRight /> Video Editing    | ምቅንባር ቪድዮ
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Haben</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
